export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8383.1fd418df.jpg";